const config: {
  base_url: string
  result_code: number | string
  default_headers: string
  request_timeout: number
} = {
  /**
   * api 请求基础路径
   * 注意：这里只用接口前缀（如 /admin-api），由 vite.config.ts 的 dev proxy 转发到后端，
   * 避免本地开发跨域问题；生产环境由 nginx 反向代理该前缀。
   */
  base_url: import.meta.env.VITE_API_URL,
  /**
   * 接口成功返回状态码
   */
  result_code: 200,

  /**
   * 接口请求超时时间
   */
  request_timeout: 30000,

  /**
   * 默认接口请求类型
   * 可选值：application/x-www-form-urlencoded multipart/form-data
   */
  default_headers: 'application/json'
}

export { config }
